import './journeyProgress.scss';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons'
import { IsWebReferenceSuffix } from '../../functions/Configuration';

export default function StepperDot(props: any) {

    var classes = classNames(
        {
            'journey-item': true,
            'stepper-step': true,
            'active': props.page === props.stepNo,
            'complete': props.page > props.stepNo
        }
    );

    const isShortJourney = localStorage.getItem('shortJourney') === 'true';
    const webReference = localStorage.getItem('webReference') || "";
    const stepLabels = isShortJourney
        ? {
            1: 'Your business',
            2: 'Choose cover',
            3: 'Your quotes'
        }
        : {
            1: 'Your business',
            2: 'Employee details',
            3: 'Choose cover',
            4: 'Your quotes'
        };
    if (IsWebReferenceSuffix(webReference, "RPO")) {
        stepLabels[1] = 'Your details'
    }

    const stepLabel = stepLabels[props.stepNo as keyof typeof stepLabels];
    let stepperID = `journey_${props.stepNo}`;

    if (localStorage.getItem('shortJourney') === "true") {
        stepperID = stepperID + "_short";
    }

    return (
        <>
            <div className={classes}>
                <div className="progress">
                    <div className="progress-bar"></div>
                </div>
                {props.page > props.stepNo &&
                    <span className="stepper-dot completed-icon"></span>
                }
                {props.page <= props.stepNo &&
                    <a href="#" className="stepper-dot">{props.stepNo}</a>
                }
                <div className="stepper-info">{stepLabel}</div>

            </div>
        </>
    )

}